<script>
  // @ts-check

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  import DynamicHeading from "../../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../../atoms/DynamicHeadingContext.svelte";
  import Link from "../../atoms/Link.svelte";

  /** The title of the NewsLetter Confirmation component
   * @type {string} */
  export let subTitle = undefined;

  /**
   * The description of the NewsLetter Confirmation component
   * @type {string}
   */
  export let description = null;

  /**
   * The call to action of the NewsLetter Confirmation component
   * @type {import('../../types/shared.js').CTA}
   */
  export let cta = null;

  let descriptionClass = "body-sm py-4 md:py-5 xl:py-7";
</script>

<DynamicHeadingContext>
  <div {id}>
    <DynamicHeading class="heading-xs pt-7 md:pt-15 lg:pt-0">
      {subTitle}
    </DynamicHeading>
    <p class={descriptionClass}>{description}</p>
    <Link class="mt-10 lg:mt-20" href={cta.url} label={cta.text} variant="large" />
  </div>
</DynamicHeadingContext>
